module.exports = globalThis.mcData["versionArray"] ?? globalThis.mcData["version"]